import styled from "@emotion/styled"
import { Card as BaseCard } from "@modules/ui/components/LegacyCard"

export const MainSection = styled(`div`)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;

  ${p => p.theme.mediaQueries.tablet} {
    flex-direction: row;
  }
`

export const ReportRow = styled(`div`)`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  button {
    flex-shrink: ;
  }
`

export const ReportSection = styled(`div`)`
  border-top: 1px solid ${p => p.theme.colors.standardLine};
  font-size: ${p => p.theme.fontSizes[1]};
  color: ${p => p.theme.colors.grey[50]};
  margin-top: ${p => p.theme.space[5]};
  padding-top: ${p => p.theme.space[5]};
`

export const ReportName = styled(`span`)`
  align-items: center;
  display: flex;

  svg,
  strong {
    margin-right: ${p => p.theme.space[2]};
  }

  ${p => p.theme.mediaQueries.tablet} {
    flex-basis: 11rem;
    flex-shrink: 0;
  }
`

export const ReportDetails = styled(`div`)`
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
`

export const ReportDetailsItem = styled(`span`)`
  align-items: center;
  display: flex;
  margin: ${p => p.theme.space[2]} ${p => p.theme.space[5]}
    ${p => p.theme.space[2]} 0;

  svg {
    margin: 0 ${p => p.theme.space[2]};
  }

  b {
    color: ${p => p.theme.colors.grey[60]};
  }

  ${p => p.theme.mediaQueries.desktop} {
    margin: 0 ${p => p.theme.space[5]} 0 0;
  }
`

export const BuildCard = styled(BaseCard)`
  display: flex;
  flex-direction: column;
  margin-bottom: ${p => p.theme.space[5]};
  padding: ${p => p.theme.space[8]};
  width: 100%;
`
